import DespesasRotas from "./despesas/DespesasRotas"
import PagamentosRotas from "./pagamento/PagamentosRotas"

export default {
    path: 'financeiro',
    name: 'DespesasGerais_Financeiro',
    component: {
        render(c) {
            return c('router-view')
        }
    }, 
    children: [DespesasRotas, PagamentosRotas]
}